import React from 'react'
import { css } from '@emotion/core'

import Logo from '../images/logo.inline.svg'
import insta from '../images/insta.png'
import fb from '../images/fb.png'
import tw from '../images/tw.png'

import { mq } from '../css/style'

const Header = ({ fill, customCss }) => {
    return (
        <header css={[headerClassFn({ fill }), customCss]}>
            <a href="https://www.deezer.com" target="blank">
                <Logo />
            </a>
            <a href="https://DeezerFR.lnk.to/Insta" target="blank">
                <img src={insta} alt="Instagram" />
            </a>
            <a href="https://DeezerFR.lnk.to/FB" target="blank">
                <img src={fb} alt="Facebook" />
            </a>
            <a href="https://DeezerFR.lnk.to/TW" target="blank">
                <img src={tw} alt="Twitter" />
            </a>
        </header>
    )
}

const headerClassFn = props => css`
    display: flex;
    align-items: flex-end;
    left: 30px;
    position: absolute;
    top: 40px;
    width: calc(100% - 60px);
    z-index: 2;

    ${mq.small(css`
        left: 120px;
        top: 60px;
        width: auto;
    `)};

    a:nth-of-type(1) {
        flex-grow: 1;
        margin-right: 60px;
        width: 130px;

        ${mq.small(css`
            margin-right: 20px;
            width: 210px;
        `)};

        img {
            display: block;
        }
    }

    a:nth-of-type(2),
    a:nth-of-type(3),
    a:nth-of-type(4) {
        height: 20px;
        width: 20px;
    }

    a:not(:first-of-type) {
        margin: 0 10px;
    }

    a:not(:first-of-type) img {
        height: 100%;
        object-fit: contain;
        width: 100%;
    }

    svg {
        vertical-align: top;
        ${props.fill &&
            `
        * {
            fill: ${props.fill};
        }`}
    }
`

export default Header
